// Get the API root URL
const apiRootURL = "https://api-achat.sage.fr:/cms/";

export default apiRootURL;